import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ItemClassificationFacade } from './item-classification.facade';
import { ZraProductDetailFacade } from './zra-product-detail.facade';
import { TaxCodesFacade } from './tax-codes.facade';
import { ZraCustomerTpinFacade } from './zra-customer-tpin.facade';
import { ZraInvoiceFacade } from './zra-invoice.facade';

@NgModule({
  imports: [CommonModule],
  providers: [
    ItemClassificationFacade,
    ZraProductDetailFacade,
    TaxCodesFacade,
    ZraCustomerTpinFacade,
    ZraInvoiceFacade
  ],
})
export class ZraSmartInvoicingModule {}
